import { Icon } from '@iconify/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { DetailsTab } from '@/Domain/components/Inbox/ConversationDetails/Tabs/DetailsTab/DetailsTab';
import { Spinner } from '@/Domain/components/Shared/Spinner';
import { SidebarCollapsedIcon } from '@/Domain/components/icons/SidebarCollapsed.icon';
import { useGetConversation } from '@/Domain/hooks/Conversation/useGetConversation.hook';

type Props = {
  isCollapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
};

export const ConversationDetails = ({ isCollapsed, onCollapsedChange }: Props) => {
  const { t } = useTranslation('inbox_v2');

  const { id } = useParams() as { id: string };

  const { conversation, isLoading } = useGetConversation(id);

  if (!conversation) {
    return null;
  }

  return (
    <div
      className={classNames('w-full ml-auto flex flex-col p-4', {
        '!bg-card flex items-center': isCollapsed,
      })}
    >
      {isCollapsed ? (
        <SidebarCollapsedIcon
          className="cursor-pointer text-muted-foreground"
          onClick={() => onCollapsedChange(false)}
        />
      ) : null}

      {isLoading && (
        <div className="flex flex-1 h-full justify-center items-center ">
          <Spinner className="h-7 w-7" />
        </div>
      )}

      {!isLoading && !isCollapsed && (
        <div
          className={classNames(
            'transition-opacity ease-in-out transform h-full flex flex-col custom-scroll',
            {
              'opacity-0': isCollapsed,
              'opacity-100 duration-700': !isCollapsed,
            },
          )}
        >
          <div className="flex items-center justify-between mb-3 pt-1">
            <h2 className="text-base font-semibold text-foreground">{t('tabs.details')}</h2>
            <Icon
              className="cursor-pointer text-muted-foreground"
              icon="mingcute:close-line"
              onClick={() => onCollapsedChange(true)}
            />
          </div>
          <div className="flex-1 overflow-y-auto">
            <DetailsTab conversation={conversation} />
          </div>
        </div>
      )}
    </div>
  );
};
